import { render, staticRenderFns } from "./ActionLink.vue?vue&type=template&id=2c8dc05c&scoped=true&"
import script from "./ActionLink.vue?vue&type=script&lang=js&"
export * from "./ActionLink.vue?vue&type=script&lang=js&"
import style0 from "./ActionLink.vue?vue&type=style&index=0&id=2c8dc05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8dc05c",
  null
  
)

export default component.exports